import React from "react";
import TableWidget from "../../components/tables/TableWidget";
import { TableActions } from "../../components/tables/tableContext/TableContext";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getRecallEntries } from "../../redux/api/recall.api";
import {
  getRecallEntriesTableData,
  recallEntriesTableHeader,
} from "./components/tableConfigs/recallEntriesTableConfig";
import RecallEntriesHeader from "./components/RecallEntriesHeader";
import RecallEntriesActionButton from "./components/TableActionsButtonsComponents/RecallEntriesActionButton";

function Recall() {
  const dispatch = useAppDispatch();
  const {
    entries: {
      data: { data: recallEntries, total },
      isLoading,
    },
  } = useAppSelector((state) => state.recall);

  const handleTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        getRecallEntries({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
        }),
      );
    }
  };

  return (
    <TableWidget
      className="[&_thead_th]:text-left"
      CustomHeaderComponent={RecallEntriesHeader}
      tableHeaderData={recallEntriesTableHeader}
      tableItemsData={getRecallEntriesTableData(recallEntries)}
      totalItems={total}
      borderedRow
      tableLoading={isLoading}
      handleTableActions={handleTableActions}
      ActionButtonsComponent={(props: any) => (
        <RecallEntriesActionButton {...props} />
      )}
    />
  );
}

export default Recall;
